<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-card tile elevation="0">
        <v-card-text class="pa-0">
          <v-container class="pb-0">
            <v-row>
              <v-col cols="6" class="pa-0">
                <v-row class="ma-0">
                  <template v-if="type == '1'">
                    <v-col cols="6" class="py-0">
                      <template-date-picker
                        :id="0"
                        :date="inquiry"
                        :label="'問合せ日'"
                        :title="false"
                        @updated="onUpdated"
                        hide-details
                      ></template-date-picker>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <v-select
                        :items="$MEDIAS"
                        label="媒体"
                        v-model="myItem.media"
                        hide-details
                        item-text="name"
                        item-value="key"
                        @change="updateNotice"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-select
                        ref="room"
                        :items="tempGroups"
                        label="教室"
                        v-model="group"
                        item-text="name"
                        item-value="key"
                        :rules="[rules.required]"
                        @change="updateNotice"
                      ></v-select>
                    </v-col>
                  </template>
                  <template v-if="type == '2' || type == '3' || type == '5'">
                    <v-col cols="8" class="py-0">
                      <template-date-picker
                        :id="3"
                        :date="myItem.date1"
                        :label="type == '5' ? (extension == 1 ? '入会日' : '入塾日') : '実施日'"
                        :title="false"
                        @updated="onUpdated"
                        :validate="validate"
                        :clearable="true"
                      ></template-date-picker>
                    </v-col>
                  </template>
                  <template v-if="type == '2' || type == '3'">
                    <v-col cols="4" class="py-0">
                      <template-time-picker
                        :id="1"
                        :time="myItem.time1"
                        :label="'時刻'"
                        @updated="onUpdated"
                      ></template-time-picker>
                    </v-col>
                  </template>
                  <template v-if="type == '1'">
                    <v-col cols="8" class="py-0">
                      <template-date-picker
                        :id="3"
                        :date="myItem.date1"
                        :label="'保護者面談日（予約）'"
                        :title="false"
                        @updated="onUpdated"
                        :hideDetails="true"
                      ></template-date-picker>
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <template-time-picker
                        :id="1"
                        :time="myItem.time1"
                        :label="'時刻'"
                        @updated="onUpdated"
                        :hideDetails="true"
                      ></template-time-picker>
                    </v-col>
                    <v-col cols="8" class="py-0">
                      <template-date-picker
                        :id="4"
                        :date="myItem.date2"
                        :label="'体験授業日（予約）'"
                        :title="false"
                        :background="''"
                        @updated="onUpdated"
                        :hideDetails="true"
                      ></template-date-picker>
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <template-time-picker
                        :id="2"
                        :time="myItem.time2"
                        :label="'時刻'"
                        @updated="onUpdated"
                        :hideDetails="true"
                      ></template-time-picker>
                    </v-col>
                  </template>
                </v-row>
              </v-col>
              <v-col cols="6" class="pa-0 pr-2">
                <template-memo
                  :label="'メモ'"
                  :event="myItem"
                  :rules="[]"
                  :attach="true"
                  :files="files"
                  @update="onUpdateMemo"
                >
                </template-memo>
              </v-col>
              <v-col cols="12" class="pt-1 pb-1">
                <template v-if="myItem.status != $STATUS_LOSE">
                  <v-row align="center">
                    <v-btn v-if="type != '1' && !myItem.imported" rounded depressed color="error" class="ml-2" @click="onPrev()">前のステップ</v-btn>
                    <v-spacer></v-spacer>
                    <template v-if="user.key != null">
                      <v-btn v-if="type != '5'" rounded depressed class="mr-0" color="success" :disabled="checkDialog()" @click="onNext()">次のステップ</v-btn>
                      <v-btn v-else rounded depressed color="success" :disabled="checkDialog()" @click="onAdmission()">{{ (extension == 1 ? '入会' : '入塾') }}</v-btn>
                      <v-tooltip bottom color="error">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" icon dark class="ml-2 mr-0" :disabled="checkDialog()" @click="secession = true"><v-icon color="red" class="ma-0 pa-0">sentiment_very_dissatisfied</v-icon></v-btn>
                        </template>
                        <span>逸失</span>
                      </v-tooltip>
                      <v-tooltip bottom color="error">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" icon dark class="mr-0" @click="remove = true"><v-icon color="red" class="ma-0 pa-0">mdi-delete</v-icon></v-btn>
                        </template>
                        <span>削除</span>
                      </v-tooltip>
                    </template>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-col>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='逸失'
        message="対応状況を逸失へ変更します。よろしいですか?"
        :dialog='secession'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='削除'
        message="生徒を削除します。削除したデータは復元できませんがよろしいですか?"
        :dialog='remove'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'
import TimePicker from '../common/TemplateTime.vue'
import DatePicker from '../common/TemplateDate.vue'
Vue.component('template-time-picker', TimePicker)
Vue.component('template-date-picker', DatePicker)
export default {
  computed: {
    ...mapGetters({
      data: 'auth/data',
      groups: 'groups/groups',
      extension: 'shared/extension'
    })
  },
  data () {
    return {
      stored: null,
      myItem: null,
      validate: false,
      menu: false,
      menu1: false,
      mtgDate1: false,
      mtgTime1: false,
      mtgDate2: false,
      mtgTime2: false,
      formHasErrors: false,
      loading: false,
      secession: false,
      remove: false,
      tempUser: null,
      tempGroups: [],
      group: null,
      inquiry: null,
      rules: {
        required: value => !!value || '必須'
      }
    }
  },
  props: [ 'user', 'item', 'type', 'files' ],
  watch: {
    user () {
      if (this.stored.key === null && this.user.key !== null) {
        this.onStore()
      }
      this.tempUser = this.user
      this.stored = this.user
    },
    item () {
      this.myItem = JSON.parse(JSON.stringify(this.item))
      if (this.item.updatedAt !== null) {
        this.inquiry = moment.unix((this.item.updatedAt / 1000)).format('YYYY-MM-DD')
      } else {
        moment.tz.setDefault('Asia/Tokyo')
        const date = new Date()
        this.inquiry = moment(date).format('YYYY-MM-DD')
      }
    }
  },
  created () {
    this.tempUser = this.user
    this.stored = this.user
    if (this.item.updatedAt !== null) {
      this.inquiry = moment.unix((this.item.updatedAt / 1000)).format('YYYY-MM-DD')
    } else {
      moment.tz.setDefault('Asia/Tokyo')
      const date = new Date()
      this.inquiry = moment(date).format('YYYY-MM-DD')
    }
    this.myItem = JSON.parse(JSON.stringify(this.item))
    this.createGroups()
  },
  methods: {
    checkDialog () {
      return (this.menu | this.menu1 | this.mtgDate1 | this.mtgTime1 | this.mtgDate2 | this.mtgTime2) === 1
    },
    createGroups () {
      this.tempGroups = []
      if (!this.data) {
        return
      }

      if (this.checkPrimary()) {
        if (this.data.order) {
          for (var i in this.data.order) {
            var index = this.groups.findIndex(group => group.key === this.data.order[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        } else {
          var keys = Object.keys(this.data.groups)
          for (i in keys) {
            if (this.data.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
      } else {
        var school = this.getPrimary()
        if (school !== null) {
          keys = Object.keys(school.groups)
          for (i in keys) {
            if (school.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
      }
      keys = Object.keys(this.tempUser.groups)
      for (i in keys) {
        if (this.tempUser.groups[keys[i]]) {
          this.group = keys[i]
        }
      }
    },
    getDateFromEvent (id) {
      var index = this.user.events.findIndex(e => e.id === 1)
      if (index !== -1) {
        if (id === 1) {
          return this.user.events[index].date1
        } else if (id === 2) {
          return this.user.events[index].date2
        }
      }
      return null
    },
    onUpdated: function (value) {
      switch (value.id) {
        case 0:
          this.inquiry = value.date
          // this.isChangeInquiry = true
          break
        case 1:
          this.myItem.time1 = value.time
          break
        case 2:
          this.myItem.time2 = value.time
          break
        case 3:
          this.myItem.date1 = value.date
          if (this.type === '2' || this.type === '3') {
            if (this.myItem.date1 === null) {
              this.myItem.time1 = null
            }
          }
          break
        case 4:
          this.myItem.date2 = value.date
          if (this.type === '2' || this.type === '3') {
            if (this.myItem.date2 === null) {
              this.myItem.time2 = null
            }
          }
          break
      }
      this.updateNotice()
    },
    updateNotice () {
      if (this.myItem.status === 1) {
        this.myItem.updatedAt = parseInt(new Date(this.inquiry).getTime())
      }
      this.$emit('update', { item: this.myItem, group: this.group, files: this.files })
    },
    onUpdateMemo: function (value) {
      this.myItem = value.item
      if (this.myItem.status === 1) {
        this.myItem.updatedAt = parseInt(new Date(this.inquiry).getTime())
      }
      this.$emit('update', { item: this.myItem, group: this.group, files: value.files })
    },
    onStore () {
      if (this.myItem.status === 1) {
        this.myItem.updatedAt = parseInt(new Date(this.inquiry).getTime())
      }
      this.$emit('store', { item: this.myItem, group: this.group })
    },
    onNext () {
      this.formHasErrors = false
      if (this.type === '1') {
        if (!this.$refs.room.validate(true)) {
          this.formHasErrors = true
        }
      }
      if (!this.formHasErrors) {
        if (this.myItem.status === 1) {
          this.myItem.updatedAt = parseInt(new Date(this.inquiry).getTime())
        }
        this.$emit('next', { item: this.myItem, group: this.group })
      }
    },
    onPrev () {
      this.$emit('prev')
    },
    onSecession () {
      this.$emit('secession')
    },
    onRemove () {
      this.$emit('delete')
    },
    onAdmission () {
      this.formHasErrors = false
      if (!this.myItem.date1) {
        this.validate = true
        this.formHasErrors = true
      }
      if (!this.formHasErrors) {
        this.$emit('admission', { item: this.myItem, group: this.group })
      }
    },
    onDismissed: function (value) {
      if (this.remove) {
        this.remove = false
        if (value) {
          this.onRemove()
        }
      }
      if (this.secession) {
        this.secession = false
        if (value) {
          this.onSecession()
        }
      }
    }
  }
}
</script>
